module.exports = __webpack_public_path__ + "assets/img/sp1.500ed787.jpg";